import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsAccessibility from "highcharts/modules/accessibility";
HighchartsAccessibility(Highcharts);

const BarChartStatistics = ({dynoTestPassData}) => {

  const getOptions = {
    chart: {
      type: "column",
      height: 360,
    },
    title: {
      text: "",
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
    },
    tooltip: {
      valueSuffix: " %",
    },
    series: dynoTestPassData?.modeList?.map((mode) => ({
      name : mode,
      data: dynoTestPassData?.List?.map((data) => data?.[mode] || 0),
      pointWidth: dynoTestPassData?.modeList?.length < 2 ? 50 : null,
      groupPadding: 0.06,
      dataLabels: {
        enabled: true,
        format: "{point.y:.0f} %",
        style: {
          fontSize: "10px",
        },
      },
    })),
    credits: {
      enabled: false,
    },
    colors: ["#5b8fe0", "#77b76f", "#e6c333", "#f07272"],
    xAxis: {
      categories: dynoTestPassData?.modelList,
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        format: '{value} %'
      },
    },
  };

  return (
    <div className="mt1">
      <HighchartsReact highcharts={Highcharts} options={getOptions} />
    </div>
  )
};

export default BarChartStatistics;
